import Vue from 'vue';
import Router from 'vue-router';
import login from "../view/user/login";
import index from "../view/board/index";
import pdtRank from "../view/board/pdtRank";
import empRank from "../view/board/empRank";
import pdtRankItem from "../view/board/pdtRankItem";


Vue.use(Router);


const scrollBehavior = function scrollBehavior(to, from, savedPosition) {
  if (savedPosition) {
    return savedPosition;
  } else {
    return { x: 0, y: 0 }
  }
};

export default new Router({
  routes: [
    {
      path: "/",
      name: "",
      component: login,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/login",
      name: "login",
      component: login,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/index",
      name: "index",
      component: index,
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/pdtRank",
      name: "pdtRank",
      component: pdtRank,
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/empRank",
      name: "empRank",
      component: empRank,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/pdtRank/item",
      name: "pdtRankItem",
      component: pdtRankItem,
      meta: {
        keepAlive: false,
      },
    },
  ],

  scrollBehavior,

})



// WEBPACK FOOTER //
// ./src/router/index.js